import React, { useContext, useEffect, useState } from 'react'
import { SearchGlobalContext } from './SearchGlobalContext'
import { Col, Container, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeftLong, faClose, faCross, faPencilAlt, faPlay } from '@fortawesome/free-solid-svg-icons'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import './search.css'
import Modal from '../Modal'
import Footer from '../Footer/Footer'
const Search = () => {
    const [searchResults, setSearchResults] = useState([])
    const [inputValue, setInputValue] = useState('')
    const [loading, setLoading] = useState('')
    const [showModal, setShowModal] = useState(false); // 👈 for modal control
    const [showbackcross, setBackCrossBtn] = useState(false)
    const user_id = localStorage.getItem('dastaan__user_id') !== null ? localStorage.getItem('dastaan__user_id') : null
    useEffect(() => {
        search()
    }, [])
    const navigate = useNavigate();
    const search = () => {
        const search_key = inputValue !== null ? inputValue : 'b';
        setLoading(true)
        const data = JSON.stringify({
            search_key
        });
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}/search`,
            headers: {
                'Authorization': localStorage.getItem('dastaan__token'),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            data: data
        };
        axios.request(config).then((response) => {
            setLoading(false)
            // console.log(response.data);
            setSearchResults(response.data.Podcast_App.search_result_data)
        })
    }
    const handleSearch = (val) => {
        setInputValue(val);
        if (val.length > 0) {
            setBackCrossBtn(true)
        }
        else {
            setBackCrossBtn(false)
        }
        search()
    }
    const clearSearch = () => {
        setBackCrossBtn(false)
        setInputValue('')
    }
    const [dw, setWidth] = useState(0)
    useEffect(() => {
        const w = window.innerWidth
        setWidth(w)
    })
    const plan_active = localStorage.getItem('dastaan__plan_active');
    return (
        <> <Container className={`p-4 ${dw > 768 ? 'ml-10' : ''}`}>
            <Row className={` search-container`}>
                <Col md={2} lg={2} xs={1} sm={2} className={`mt-3 ${showbackcross === false ? 'none' : ''}`} onClick={clearSearch}>
                    <FontAwesomeIcon className={'text-white search-backbutton'} icon={faArrowLeftLong} />
                </Col>
                <Col md={12} lg={12} xs={showbackcross === false ? 12 : 11} sm={12} className='mb-4'>
                    <input
                        placeholder=' 🔍  Search audio'
                        style={{ width: showbackcross === true ? '100%' : (dw <= 768 ? "100%" : "80%") }}
                        className='search-input-box'
                        value={inputValue}
                        onChange={(e) => {
                            const value = e.target.value;
                            setInputValue(value);
                            handleSearch(e.target.value);
                        }}
                    />
                    <div className={`search-erase-btn ${showbackcross === false ? 'none' : ''}`} onClick={clearSearch}>
                        <FontAwesomeIcon className={'text-white search-backbutton'} icon={faClose} />
                    </div>
                </Col>
                <Col md={12} lg={12} xs={12} sm={12} className=''>
                    <h5 className='search-heading'>Top Searches</h5>
                </Col>
                {
                    searchResults.map((audFile) => (
                        <Col md={2} sm={4} xs={4} className='mt-2 p-1'>
                            {/* <Link to={`/audio-file-detail/${audFile.audio_file_id}`} onClick={() => searchResults([])}                  > */}
                            <div
                                // onClick={() => user_id !== null ? navigate(`/audio-file-detail/${audFile.audio_file_id}`) : setShowModal(true)}
                                onClick={() => (user_id !== null && plan_active === 'true') ? navigate(`/audio-file-detail/${audFile.audio_file_id}`) : (user_id !== null && plan_active === 'false' ? navigate('/plans') : setShowModal(true))}
                              
                                key={audFile.audio_file_id} className="card-wrapper">
                                <div className="card">
                                    <div className='image'>
                                        <img src={audFile.landscape_thumb} alt={audFile.title} className="slick-slider-img" />
                                    </div>
                                </div>
                            </div>
                            {/* </Link> */}
                        </Col>
                    ))
                }
            </Row>
            <Modal show={showModal} onClose={() => setShowModal(false)} />
        </Container>
        </>
    )
}
export default Search